import authCheckApp from './authCheckApp'

/**
 * 隐藏加载框
 * @since 1.0.0
 * @example
 * 
 * webViewReset()
 */
function webViewReset() {
    authCheckApp()
        .then(() => {
        // 发起请求
            window.WebViewJavascriptBridge.callHandler('webViewReset', {}, (response) => {
                return response
            })
        })
}

export default webViewReset